<div *ngIf="DayContactForm" class="day-contact-info-step-container" [id]="containerId">
    <form [formGroup]="DayContactForm">
        <div class="date-container">
            <div class="contact-title" style="margin-bottom: 0px;">
                <img src="assets/icons/new-service-calendar.svg" alt="User icon" />
                <span>{{'EDIT_SERVICES.DAY_CONTACT.0' | translate}}</span>
            </div>


            <label class="standard-label" style="margin-top: 15px;">
                {{'EDIT_SERVICES.DAY_CONTACT.3' | translate}}
            </label>
            <div style="margin-top: 10px;">
                <app-date-input [today]="true" [dateValue]="StartDateObject?.Date ?? ''"
                    [dateInputFormat]="'DD-MM-YYYY'" (dateValueEmitter)="onDateChange($event)"></app-date-input>
            </div>


            <label class="standard-label" style="margin-top: 15px;">
                {{'EDIT_SERVICES.DAY_CONTACT.4' | translate}}
            </label>
            <div style="margin-top: 10px;"
                *ngIf="!ES_Zones.includes(ServiceForm?.value.AddressData.OriginAddress.ZoneId)">
                <app-select-by-keys-dropdown [translateKey]="'EDIT_SERVICES.DAY_CONTACT.'"
                    [dataArray]="PickUpHourTypeList" [selectedKey]="PickUpHourTypeSelected"
                    (optionEmitter)="onPickUpTypeChange($event)"></app-select-by-keys-dropdown>
            </div>




            <div *ngIf="!NotHoursAvailable">
                <div style="margin-top: 10px;" *ngIf="PickUpHourTypeSelected == PickUpHourType.SPECIFIC">
                    <app-select-by-keys-dropdown [placeholder]="'EDIT_SERVICES.DAY_CONTACT.10' | translate"
                        [dataArray]="hoursOfDaySpecific" [loading]="LoadingAvailableHours"
                        [selectedKey]="SpecificHourSelected.Start && SpecificHourSelected.End ? (SpecificHourSelected.Start + ' - ' + SpecificHourSelected.End) : ''"
                        (optionEmitter)="onRangeHourChange($event)"></app-select-by-keys-dropdown>
                </div>


                <div class="range-inputs-container" style="margin-top: 15px;"
                    *ngIf="PickUpHourTypeSelected == PickUpHourType.RANGE">
                    <div class="flex-1">
                        <label class="standard-label">
                            {{'EDIT_SERVICES.DAY_CONTACT.5' | translate}}
                        </label>
                        <app-select-by-keys-dropdown [dataArray]="hoursOfDay" [loading]="LoadingAvailableHours"
                            [selectedKey]="StartDateObject?.Hour"
                            [placeholder]="'EDIT_SERVICES.DAY_CONTACT.5' | translate"
                            (optionEmitter)="onStartHourChange($event)"></app-select-by-keys-dropdown>
                    </div>

                    <div class="flex-1">
                        <label class="standard-label">
                            {{'EDIT_SERVICES.DAY_CONTACT.6' | translate}}
                        </label>
                        <app-select-by-keys-dropdown [dataArray]="hoursOfDayEndDate" [loading]="LoadingAvailableHours"
                            [selectedKey]="EndDateObject?.Hour"
                            [placeholder]="'EDIT_SERVICES.DAY_CONTACT.6' | translate"
                            (optionEmitter)="onEndHourChange($event)"></app-select-by-keys-dropdown>
                    </div>
                </div>
            </div>

            <div *ngIf="NotHoursAvailable" class="date-error-message">
                {{'EDIT_SERVICES.DAY_CONTACT.7' | translate}}
            </div>

            <div *ngIf="NotRangeAvailable && PickUpHourTypeSelected == PickUpHourType.RANGE" class="date-error-message">
                {{'EDIT_SERVICES.DAY_CONTACT.8' | translate}}
            </div>

            <!-- <app-date-input style="margin-top: 10px;" [dateValue]="StartDateObject?.Date" [dateInputFormat]="'DD-MM-YYYY'"
            (dateValueEmitter)="onDateChange($event)"></app-date-input> -->
        </div>


        <div class="split"></div>
        <div class="contacts-container">
            <div class="contact-title">
                <img src="/assets/icons/new-service-user.svg" alt="User icon" />
                <span>{{'EDIT_SERVICES.DAY_CONTACT.1' | translate}}</span>
            </div>

            <app-service-contact-form [ContactForm]="originContactFormGroup" [ShowExternalContainer]="true"
                [ShowEmailOptional]="true"></app-service-contact-form>

            <div class="check-box d-flex flex-row justify-content-start align-items-center mg-t15"
                (click)="togglePickupContactSamePerson()">
                <input type="checkbox" name="pickup-contact-same-person" id="pickup-contact-same-person"
                    [checked]="pickupContactSamePerson" />
                <label>{{
                    'samePickupAndDeliveryContact' | translate
                    }}</label>
            </div>


            <div class="contact-title mg-t30" *ngIf="!pickupContactSamePerson" [id]="DestinationContainerId">
                <img src="/assets/icons/new-service-user.svg" alt="User icon" />
                <span>{{'EDIT_SERVICES.DAY_CONTACT.2' | translate}}</span>
            </div>

            <app-service-contact-form *ngIf="!pickupContactSamePerson" [ContactForm]="destinationContactFormGroup"
                [ShowExternalContainer]="true" [ShowEmailOptional]="true"></app-service-contact-form>
        </div>


        <!-- <div *ngIf="BillingCentersAvailable">
            <div class="split"></div>
            <app-billing-center-step [ScrollParentId]="containerId"
                [BillingAddressSelected]="DayContactForm.get(FORM_KEYS.BillingAddress)?.value"
                (billingContactEmitter)="billingContactEmitter($event)"></app-billing-center-step>
        </div> -->

        <div>
            <div class="split"></div>
            <app-custom-fields-manager [showTitle]="true" [showDescription]="true" [SummaryData]="FakeSummaryData"
                (updateSummaryDataEmitter)="updateSummaryDataEmitter($event)"></app-custom-fields-manager>
        </div>

        <div>
            <div class="split"></div>
            <app-contact-details-step [form]="DayContactForm"
                [formControlName]="FORM_KEYS.Comments"></app-contact-details-step>
        </div>


    </form>


</div>